import { Row } from 'antd';
import type { RowProps } from 'antd';

export interface DRowProps extends RowProps {}

export const DarwinRow = (props: DRowProps) => {
  return <Row {...props} />;
};
